
import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import stores from '@/stores';
import Axios from 'axios';
import {mixin as Clickaway} from 'vue-clickaway';
import {SweetModal} from 'sweet-modal-vue';
import vPagination from '@/components/VuePlainPagination.vue';
import CreateUser from './Create.vue';
import NevronSearchNoResults from '@/components/NevronSearchNoResults.vue';
import NevronSearch from '@/components/NevronSearch.vue';
import _ from 'lodash';
import axiosInstance from '@/helpers/axios';
import CreateCrewCast from '@/modules/Series/List/CreateCrewCast.vue';
import SeriesModules from '@/stores/modules/Series';
import {showToaster} from '@/components/DashboardComposer/helpers';
import {translate} from '@/helpers/functions';

@Component({
  components: {
    CreateCrewCast,
    SweetModal,
    vPagination,
    NevronSearchNoResults,
    NevronSearch,
  },
  mixins: [Clickaway],
})

export default class AttachCrewCastTo extends Vue {
  @Prop()
  module!: SeriesModules;
  @Prop()
  fullRes!: any;
  @Prop()
  instance!: any;

  @Prop()
  accId!: number;

  response: any = null;
  items: any = null;
  crewIndexList: number[] = [];
  castIndexList: number[] = [];
  allChecked: boolean = false;
  searchQuery: string = '';
  searchUsers = _.debounce((res: any) => {
    this.fetchCreworCast(res);
  }, 400);

  mounted() {
    this.fetchCreworCast();
  }

  save() {
    this.attachCrew(this.crewIndexList);
    this.attachCast(this.castIndexList);

    // this.$emit('attach', this.crewIndexList);
    // this.cancel();
  }

  attachCrew(ids: number[]) {
    if (ids.length > 0) {
      return this.module.attachCrew(ids, Number(this.$route.params.id))
        .then((response: any) => {
          if (!response.success) {
            showToaster('danger', '', response.error.message, response.responseCode);
          } else {
            showToaster('success', '', translate('crew-attached-message'));
            this.$emit('attach', this.crewIndexList);
            this.cancel();
          }
        });
    }
  }

  attachCast(ids: number[]) {
    if (ids.length > 0) {
      return this.module.attachCast(ids, Number(this.$route.params.id))
        .then((response: any) => {
          if (!response.success) {
            showToaster('danger', '', response.error.message, response.responseCode);
          } else {
            showToaster('success', '', translate('cast-attached-message'));
            this.$emit('attach', this.castIndexList);
            this.cancel();
          }
        });
    }
  }

  cancel() {
    this.$emit('attach');
    // @ts-ignore
    this.$children[0].close();
    this.allChecked = false;
  }

  @Watch('response.currentPage')
  fetchCreworCast(index = 1) {
    // @ts-ignore
    return this.module.fetchCrewCastData(index, this.searchQuery, 10)
      .then((response: any) => {
        this.response = response;
        this.items = response;
      })
      .catch((e: any) => {
        console.log(e);
      });
  }
  get filteredCrews() {
    return this.items.crews.filter((item: any) => {
      return !this.instance.crews.some((crew: any) => crew.id === item.id);
    });
  }

  get filteredCasts() {
    return this.items.casts.filter((item: any) => {
      return !this.instance.casts.some((cast: any) => cast.id === item.id);
    });
  }
}
